import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import Breadcrumb from 'component/Breadcrumb'
import ContentHeader from 'component/utils/ContentHeader'
import JustificationDemarcateTable from 'component/justificationDemarcate/JustificationDemarcateTable'
import JustificationDemarcateEditForm from 'component/justificationDemarcate/JustificationDemarcateForm'
import Grid from 'component/utils/Grid'
import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'

import * as justificationDemarcateActions from 'action/justificationDemarcate'

class JustificationDemarcate extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    current: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    fetchJustificationDemarcateList: PropTypes.func.isRequired,
    updateJustificationDemarcate: PropTypes.func.isRequired,
    removeJustificationDemarcate: PropTypes.func.isRequired,
    justifications: PropTypes.array.isRequired,
    translate: PropTypes.func.isRequired,
    error: PropTypes.object,
  }

  state = {
    justification: { dsJustificationDemarcate: '' },
  }

  componentDidMount() {
    this.handleFetchJustification()
  }

  handleFetchJustification = (page) => {
    const {
      auth: { user },
      fetchJustificationDemarcateList,
    } = this.props

    fetchJustificationDemarcateList(user.dsToken, page)
  }

  updateJustificationIsActive = (justification) => {
    const {
      auth: { user },
      updateJustificationDemarcate,
    } = this.props

    const values = {
      ...justification,
      inInactive: justification.inInactive === 0 ? 1 : 0,
    }

    updateJustificationDemarcate(user.dsToken, values)
  }

  saveJustification = (values) => {
    const {
      auth: { user },
      updateJustificationDemarcate,
    } = this.props

    updateJustificationDemarcate(user.dsToken, values)

    this.setState({
      justification: { dsJustificationDemarcate: '' },
    })
  }

  handleEditJustification = (justification) => {
    this.setState({
      justification,
    })
  }

  handleRemoveJustification = (justification) => {
    const {
      auth: { user },
      removeJustificationDemarcate,
    } = this.props

    const id = {
      idJustificationDemarcate: justification.idJustificationDemarcate,
    }

    removeJustificationDemarcate(user.dsToken, id)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('menu.demarcate') },
      { title: translate('demarcate.justification') },
    ]

    return <Breadcrumb steps={steps} />
  }

  renderPagination = () => {
    const { pages } = this.props

    if (!pages || pages < 2) {
      return null
    }

    const { current, count } = this.props

    return (
      <Col className='align-center margin-top'>
        <Pagination
          getPage={this.handleFetchJustification}
          pages={pages}
          current={current}
          count={count}
        />
      </Col>
    )
  }

  shouldRenderJustifications = () => {
    const { justifications } = this.props

    if (!justifications || justifications.length < 1) {
      return false
    }

    return true
  }

  render() {
    const { translate, justifications } = this.props
    return (
      <div>
        <ContentHeader>
          {translate('demarcate.justification.title')}
        </ContentHeader>
        {this.renderBreadcrumb()}
        <Grid fluid>
          {' '}
          {/* Demarcate Justification */}
          <Col
            lg={6}
            lgOffset={3}
            md={6}
            mdOffset={3}
            sm={12}
            xs={12}
            className='margin-top'
          >
            <h4>{translate('demarcate.justification.title')}</h4>
          </Col>
          {this.shouldRenderJustifications() && (
            <div>
              <Col
                lg={6}
                lgOffset={3}
                md={6}
                mdOffset={3}
                sm={12}
                xs={12}
                className='align-center margin-top'
              >
                <JustificationDemarcateTable
                  translate={translate}
                  justifications={justifications}
                  updateJustificationIsActive={this.updateJustificationIsActive}
                  editJustification={this.handleEditJustification}
                  removeJustification={this.handleRemoveJustification}
                />
              </Col>
              {this.renderPagination()}
            </div>
          )}
          <JustificationDemarcateEditForm
            updateJustification={this.handleEditJustification}
            justification={this.state.justification}
            translate={translate}
            onSubmit={this.saveJustification}
          />
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = ({
  justificationDemarcateReducer,
  paginateReducer,
}) => ({
  justifications: justificationDemarcateReducer.list.records,
  error: justificationDemarcateReducer.edit.error,
  pages: paginateReducer.pages,
  count: paginateReducer.count,
  current: paginateReducer.current,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(justificationDemarcateActions, dispatch)

const HomeTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(JustificationDemarcate)

export default connect(mapStateToProps, mapDispatchToProps)(HomeTranslated)

export { JustificationDemarcate }
